<template>
  <div class="c-inbox-item" v-if="notification">
    <!-- <button class="c-inbox-item__close" type="button"><i class="icon16-close-line-black"></i></button> -->
    <div class="c-inbox-item__title" :for="`title_${notification._id}`" @click="readNotification">
      <div class="c-inbox-item__title__left">
        <span class="c-inbox-item__icon" :class="bgClass"><i :class="iconClass"></i></span>
        <label>
          <b>{{ notification.title }}</b>
        </label>
      </div>
      <div class="c-inbox-item__title__center">
        {{ notification.content }}
      </div>
      <div class="c-inbox-item__title__right" v-if="$store.state.user.permissions.find(p => p ==='notificationListAll' || p === 'notificationListGroup') && notification.user">
        {{ notification.user.name }}&nbsp;({{ notification.user.ext }})
      </div>
      <div class="c-inbox-item__title__right">
        <span class='badge' :class="seenClass">{{seen}}</span>
        <span class="c-inbox-item__time">{{ notification.updateTime | moment('DD/MM/YYYY HH:mm') }}</span>
      </div>
    </div>
    <div v-if="['newCustomer', 'missCall', 'newTask', 'dueTask', 'overdueTask', 'newEmail'].includes(notification.type)" class="c-inbox-item__content" :for="`details_${notification._id}`">
      <div class="c-inbox-item__text" v-for="target in targets" :key=target._id>
        <!-- <div class="c-inbox-item__title__left"></div> -->
        <p>
          <span v-if="notification.type === 'newCustomer'">
            <template v-if="target.customer">
              {{$t('customer')}}
              <b>{{target.customer.name}}</b> | <a @click="readTargetCustomer(target)" href="javascript:;"> {{$t('seeDetail')}} </a>
            </template>
            <span v-else>{{$t('deletedCustomer')}}</span>
            <a v-if="$store.state.user._id === notification.user._id && !target.readTime" href="javascript:;" @click="readTarget(target)">
              | {{$t('markAsSeen')}}
            </a>
          </span>
          <span v-if="notification.type === 'missCall' && target.call">
            {{$t('fromNumber')}}
            <b>{{target.call.fromNumber}}</b>
            | {{$t('callTime')}}: <b>{{target.call.startTime | moment('DD/MM/YYYY HH:mm:ss')}}</b>
            | <call-detail :callId="target.call._id"></call-detail>
            | <a @click="readTargetCall(target)" href="javascript:;"> {{$t('callBackNow')}} </a>
            <a v-if="$store.state.user._id === notification.user._id && !target.readTime" href="javascript:;" @click="readTarget(target)">
              | {{$t('markAsSeen')}}
            </a>
            <span :for="target._id"></span>
          </span>
          <span v-if="['newTask', 'dueTask', 'overdueTask'].includes(notification.type) && target.task">
            <b>{{target.task.desc}}</b> 
            | {{$t('dueTime')}}: <b>{{target.task.dueTime | moment('DD/MM/YYYY HH:mm')}}</b>
            | <a @click="readTargetCustomer(target)" href="javascript:;"> {{$t('seeDetail')}} </a>
            <a v-if="$store.state.user._id === notification.user._id && !target.readTime" href="javascript:;" @click="readTarget(target)">
              | {{$t('markAsSeen')}}
            </a>
            <span :for="target._id"></span>
          </span>
          <span v-if="notification.type === 'newEmail' && target.email">
            <b>{{target.email.subject}}</b> ({{$t('fromEmail')}}: {{target.email.fromEmail}})
            | <a @click="readTargetCustomer(target)" href="javascript:;"> {{$t('seeDetail')}} </a>
            <a v-if="$store.state.user._id === notification.user._id && !target.readTime" href="javascript:;" @click="readTarget(target)">
              | {{$t('markAsSeen')}}
            </a>
            <span :for="target._id"></span>
          </span>
          <span v-if="target.readTime" class="small text-grey-999">({{$t('readTime')}}: {{target.readTime | moment('DD/MM/YYYY HH:mm:ss')}})</span>
        </p>
      </div>
    </div>
    <div v-else :for="`details_${notification._id}`">
      <div class="c-inbox-item__title"></div>
      <div class="c-inbox-item__content">
        <div class="c-inbox-item__text">
          <p v-html="notification.content"></p>
          <span v-if="notification.readTime" class="small text-grey-999">({{$t('readTime')}}: {{notification.readTime | moment('DD/MM/YYYY HH:mm:ss')}})</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import CallDetail from '@/components/CallDetail';
import console from 'console';
export default {
  props: ['item'],
  components: {CallDetail},
  data() {
    return {
      notification: this.item,
      targets: this.item.targets && this.item.targets.length ? this.item.targets.reverse() : [],
      seen: this.$t('seen'),
      seenClass: 'badge-success',
      model: {}
    }
  },
  computed: {
    iconClass() {
      if (this.item.type === 'newEmail') {
        return 'fa fa-envelope'
      }
      if (['system', 'lowCreditBalance','expireSoon', 'trialExpireSoon'].includes(this.item.type)) {
        return 'fa fa-bell'
      }
      if (this.item.type === 'opportunity') {
        return 'fa fa-trophy'
      }
      if (['customer', 'newCustomer'].includes(this.item.type)) {
        return 'fa fa-user'
      }
      if (['task', 'dueTask', 'overdueTask', 'missCall'].includes(this.item.type)) {
        return 'fa fa-thumb-tack'
      }
      return 'fa fa-thumb-tack'
    },
    bgClass() {
      if (['system', 'lowCreditBalance','expireSoon', 'trialExpireSoon'].includes(this.item.type)) {
        return 'bg-primary'
      }
      if (['task', 'overdueTask', 'missCall'].includes(this.item.type)) {
        return 'bg-brown'
      }
      return 'bg-info-dark'
    },
  },
  watch: {
    notification: {
      handler() {
        this.loadNotificationStatus();
      }, deep: true
    }
  },
  methods: {
    toggleDetails() {
      let ref = this;
      $("div[for^=details]").hide();
      $(`div[for=title_${ref.item._id}]`).click(function () {
        if ($(`div[for=details_${ref.item._id}]`).is(':hidden')) {
          $(`div[for=details_${ref.item._id}]`).show();
        } else {
          $(`div[for=details_${ref.item._id}]`).hide()
        }
      });
    },
    readNotification() {
      if (this.$store.state.user._id.toString() === this.item.user._id.toString() && !this.notification.readTime) {
        this.$service.put("/notification/read-notification/" + this.item._id).then((res) => {
          if (!res) {
            console.log('Read notification fail!')
          } else {
            console.log("Read notification successfully");
            this.notification.readTime = Date.now();
          }
        }).catch(error => {
          console.log('Error while reading notifcation: ' + error)
        })
      } else {
        console.log('Not reading notification')
      }
    },
    readTargetCustomer(target) {
      if (this.notification.user === this.$store.state.user._id) {
        this.readTarget(target);
      }
      this.seeCustomerDetail(target.customer._id);
    },
    readTargetCall(target) {
      if (this.notification.user === this.$store.state.user._id) {
        this.readTarget(target);
      }
      this.makeCall(target.call.fromNumber);
    },
    readTarget(target) {
      if (!target.readTime) {
        $(`span[for=${target._id}]`).html('<div class="spinner-border spinner-border-sm text-primary" role="status"><span class="sr-only">Loading...</span></div>');
        this.$service.put("/notification/read-target/" + this.item._id + "/" + target._id, this.model).then((res) => {
          if (!res) {
            console.log('Read target fail!')
          } else {
            console.log('Read target successfully');
            target.readTime = Date.now();
            $(`span[for=${target._id}]`).html('');
          }
        }).catch(error => {
          console.log('Error read target: ' + error)
        })
      } else {
        console.log('Not reading target')
      }
    },
    seeCustomerDetail(customerId) {
      location.href = '#/customer/' + customerId;
    },
    makeCall(number) {
      this.$bus.$emit('makeCall', number);
    },
    reloadInbox() {
      this.$bus.$emit('reloadNoti');
    },
    loadNotificationStatus() {
      if (this.notification.targets && this.notification.targets.length) {
        let seenTargetCount = this.notification.targets.filter(t => t.readTime).length;
        let totalTargetCount = this.notification.targets.length;
        this.seen = this.$t('seenCount', [seenTargetCount, totalTargetCount]);
      } else {
        if (this.notification.readTime) {
          this.seen = this.$t('seen')
        } else {
          this.seen = this.$t('notSeen')
        }
      }
      if (this.notification.targets && this.notification.targets.length) {
        if (this.notification.targets.find(t => !t.readTime)) {
          this.seenClass = this.notification.readTime ? 'badge-warning' : 'badge-danger'
        } else {
          this.seenClass = 'badge-success'
        }
      } else {
        if (this.notification.readTime) {
          this.seenClass = 'badge-success'
        } else {
          this.seenClass = 'badge-danger'
        }
      }
    }
  },
  mounted() {
    this.loadNotificationStatus();
    this.toggleDetails();
  }
}
</script>